import { defineView } from "@/ReactSetup/view-definitions";

const definition = defineView({
    name: "CheckoutReceipt",
    component: () => (__SERVER__ ? require("./checkout-receipt-view") : import("./checkout-receipt-view"))
});

export default definition;
